// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"Titles_pageTitle__3kO4R","pageSubtitle":"Titles_pageSubtitle__1PmQQ"};